export {};
//# sourceMappingURL=Loader.types.js.map